import MEDIAS_BASE_URL from "./mediasBaseUrl";

const BASE_URL_TECHS = `${MEDIAS_BASE_URL}/techs`

const techsData = [
  {
    id: 1,
    imgSrc: `${BASE_URL_TECHS}/1-java.svg`,
    caption: "Java",
  },
  {
    id: 2,
    imgSrc: `${BASE_URL_TECHS}/2-spring.svg`,
    caption: "Spring",
  },
  {
    id: 3,
    imgSrc: `${BASE_URL_TECHS}/3-javascript.svg`,
    caption: "JavaScript",
  },
  {
    id: 4,
    imgSrc: `${BASE_URL_TECHS}/4-typescript.svg`,
    caption: "TypeScript",
  },
  {
    id: 5,
    imgSrc: `${BASE_URL_TECHS}/5-html5.svg`,
    caption: "HTML5",
  },
  {
    id: 6,
    imgSrc: `${BASE_URL_TECHS}/6-css3.svg`,
    caption: "CSS3",
  },
  {
    id: 7,
    imgSrc: `${BASE_URL_TECHS}/7-react.svg`,
    caption: "React",
  },
  {
    id: 8,
    imgSrc: `${BASE_URL_TECHS}/8-git.svg`,
    caption: "Git",
  },
  {
    id: 9,
    imgSrc: `${BASE_URL_TECHS}/9-postgresql.svg`,
    caption: "PostgreSQL",
  },
  {
    id: 10,
    imgSrc: `${BASE_URL_TECHS}/10-kotlin.svg`,
    caption: "Kotlin",
  },
  {
    id: 11,
    imgSrc: `${BASE_URL_TECHS}/11-docker.svg`,
    caption: "Docker",
  },
  {
    id: 12,
    imgSrc: `${BASE_URL_TECHS}/12-postman.svg`,
    caption: "Postman",
  },
  {
    id: 13,
    imgSrc: `${BASE_URL_TECHS}/13-ionic.svg`,
    caption: "Ionic",
  },
  {
    id: 14,
    imgSrc: `${BASE_URL_TECHS}/14-angular.svg`,
    caption: "Angular",
  },
  {
    id: 15,
    imgSrc: `${BASE_URL_TECHS}/15-vue.svg`,
    caption: "Vue",
  },
  {
    id: 16,
    imgSrc: `${BASE_URL_TECHS}/16-android.svg`,
    caption: "Android",
  },
  {
    id: 17,
    imgSrc: `${BASE_URL_TECHS}/17-aws.svg`,
    caption: "Aws",
  },
  {
    id: 18,
    imgSrc: `${BASE_URL_TECHS}/18-heroku.svg`,
    caption: "Heroku",
  },
];

export default techsData;
